const FALLBACK = "/projects";
// Any origin we can tell apart from a real one; only the comparison matters.
const PROBE_ORIGIN = "http://same-origin.invalid";
const AUTHORIZE_PREFIX = "/oauth/authorize?";

/** Keeps `next` only as a path on this origin, because "//host", "/\host"
 *  and a tab-split "/\t/host" all start with "/" and still leave the site. */
export function safeNext(raw: string | null): string {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//")) return FALLBACK;
  if (raw.includes("\\")) return FALLBACK;
  for (const ch of raw) {
    const code = ch.charCodeAt(0);
    if (code < 0x20 || code === 0x7f) return FALLBACK;
  }
  // The parser gets the last word, since dot segments ("/.//host") resolve to
  // a "//" path the prefix check above never saw.
  try {
    const url = new URL(raw, PROBE_ORIGIN);
    if (url.origin !== PROBE_ORIGIN || url.pathname.startsWith("//")) {
      return FALLBACK;
    }
  } catch {
    return FALLBACK;
  }
  return raw;
}

/** The client_id of an MCP authorize request carried in `next`, if it is one. */
export function authorizeClientId(next: string): string | null {
  if (!next.startsWith(AUTHORIZE_PREFIX)) return null;
  const id = new URLSearchParams(next.slice(AUTHORIZE_PREFIX.length)).get(
    "client_id",
  );
  return id || null;
}
